import React from "react";
import { useNavigate } from "react-router-dom";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./SiteMap.css";

const SiteMap = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "Shop",
      icon: "fa fa-shopping-bag",
      links: [
        { label: "Home", path: "/" },
        { label: "All Products", path: "/search" },
        { label: "Specials", path: "/specials" },
        { label: "Brands", path: "/brands" },
      ],
    },
    {
      title: "My Account",
      icon: "fa fa-user",
      links: [
        { label: "Login", path: "/login" },
        { label: "Register", path: "/register" },
        { label: "My Orders", path: "/myAccounts" },
        { label: "Wish List", path: "/wishList" },
        { label: "Edit Profile", path: "/edit" },
        { label: "Address Book", path: "/addressBook" },
      ],
    },
    {
      title: "Customer Service",
      icon: "fa fa-headphones",
      links: [
        { label: "Contact Us", path: "/contact-us" },
        { label: "Returns", path: "/returns" },
        { label: "Help & FAQ", path: "/help-faq" },
        { label: "Newsletter", path: "/newslatter" },
      ],
    },
    {
      title: "Extras",
      icon: "fa fa-star",
      links: [
        { label: "Affiliates", path: "/affiliates" },
        { label: "Gift Certificates", path: "/gift-certificates" },
        { label: "Vendor Terms & Conditions", path: "/vendor-terms" },
        { label: "Register as Vendor", path: "/register?vendor=true" },
      ],
    },
  ];

  return (
    <div>
      <CartBannerComponent title="Site Map" />
      <div className="container sitemap-container my-5">
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h2 className="section-title">Site Map</h2>
            <p className="text-muted">Find everything on MadeInBangladesh.info quickly and easily.</p>
          </div>
        </div>
        <div className="row">
          {sections.map((section, i) => (
            <div key={i} className="col-md-3 col-sm-6 mb-4">
              <div className="sitemap-section p-4 h-100">
                <div className="d-flex align-items-center mb-3">
                  <div className="sitemap-icon mr-3"><i className={section.icon} /></div>
                  <h5 className="font-weight-bold mb-0">{section.title}</h5>
                </div>
                <ul className="sitemap-list">
                  {section.links.map((link, j) => (
                    <li key={j}>
                      <span className="sitemap-link" onClick={() => navigate(link.path)}>
                        <i className="fa fa-angle-right mr-2" />
                        {link.label}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SiteMap;